
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteTech from "./ModalDeleteTech";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import ModalHostList from "./ModalHostLis";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '35%',
    padding: '20px'
  },
};
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "90%",
    padding: "20px",
  },
};
const TechList = ({
  pageActual,
  limitList, startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({})
  const [hostsListModalOpen, setHostsListModalOpen] = useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const [source, setSource] = useState('')
  const handleHostLisClick = (data, source) => {
    setSource(source)
    openHostsListModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  function openHostsListModal() {
    setHostsListModalOpen(true);
  }

  function closHostsListModal() {

    setHostsListModalOpen(false);
  }
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/tech_devices/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };

  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio" + mode}
                key={indice}
              >
                <div className="field-body-table-mantenimiento field-small">
                  <div className='cont-checkbox'>
                    <input type='checkbox' checked={poolRows.some((row) => row === elemento.dispId)} className='NotifiCheckBox ' style={{ height: '15px' }} onClick={() => rowSelected(elemento)} ></input>
                  </div>
                </div>
                <div className="field-body-table-mantenimiento field-medium">
                  {elemento.dispId}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '22%' }}>
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.visible_name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '17%' }} >
                  {elemento.description}
                </div>
                <div className="field-body-table-mantenimiento field-larger fieldWFstatus" >
                  {elemento.host_count}
                  <div style={{ width: '35%' }} className="">
                    <img
                      src={
                        "/iconos/review.png"
                      }
                      onClick={() => handleHostLisClick(elemento, 'unknown_hosts')}
                      name="Ver" title='Ver' className="btnAction delteException" style={{ width: '65%' }}
                    />
                  </div>
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  {/* <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div> */}

                  {/* <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div> */}

                </div>
              </div>
            ))
        )}
        {dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteTech handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteTech>
      </Modal>
      <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalHostList source={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListModal}></ModalHostList>
      </Modal>
    </>
  );
};

export default TechList;
